// styles.tsx
import styled from 'styled-components';
import { normalizeHeight, normalizeWidth } from '../../utils/normalize';
import { newNormalizeHeight, newNormalizeWidth } from '../../utils/normalize';
import { normalizeHeightToVH, normalizeWidthToVW } from '../../utils/normalize';

export const LogoWrapper = styled.div`
  position: absolute;
  top: ${normalizeHeightToVH(25)};
  left: ${normalizeWidthToVW(36)};
  width: ${normalizeWidthToVW(88)};
  height: ${normalizeHeightToVH(35)};
  z-index: 1;
`;

export const TextsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Title = styled.p`
  color: #4D4D4D;
  text-align: center;
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
`;

export const SubTitle = styled.p`
  color: #666;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 125%;
`;

export const FormContainer = styled.div`
  position: absolute;
  top: ${normalizeHeightToVH(355)};
  left: ${normalizeWidthToVW(152)};

  z-index: 1;
`;

export const FormContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 36px;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  justify-content: center;
  align-items: center;
`;

export const FormBottomContainer = styled.div`
  position: absolute;
  bottom: ${newNormalizeHeight(31)}px;
  left: ${normalizeWidthToVW(152)};

  z-index: 1;
`;

export const BottomContainer = styled.div`
  // position: absolute;
  // bottom: ${normalizeHeightToVH(31)};
  // left: ${normalizeWidthToVW(200)};
  margin-left: ${newNormalizeWidth(60)}px;
  gap: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const SignInButtons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 8px;
`;

export const SignButton = styled.div`
  cursor: pointer;
`
export const BackgroundImg = styled.img`
  position: absolute;
  top: 0;
  right: 0;
  z-index: 0;
  overflow: hidden;
  min-height: ${newNormalizeHeight(900)};
  min-width: ${newNormalizeWidth(1440)};
  height: 100%;
`;
